const SAFE_IMAGE_LINK_SCHEMES = new Set(["http", "https", "mailto", "tel"]);

export function normalizeImageHref(rawHref?: string): string {
  const href = (rawHref ?? "").trim();
  if (!href) return "";

  const scheme = href.match(/^([a-z][a-z0-9+.-]*):/i)?.[1]?.toLowerCase();
  if (scheme) return SAFE_IMAGE_LINK_SCHEMES.has(scheme) ? href : "";
  if (href.startsWith("//")) return `https:${href}`;
  return `https://${href}`;
}
